import http from "../http-common"

class RegulatoryFocusServices {
    getAllRegulatoryFocus(pathId:string) {
        return http.get(`/page-menu/${pathId}`)
    }
}


export default new RegulatoryFocusServices();